import { get } from 'lodash'
import numeral from 'numeral'

import { Colors } from '@sigma-frontend-libs/commons'
import { MODERATION_VALUES } from '@sigma-legacy-libs/essentials/lib/constants'
import { SendingTypes } from '@sigmasms/shared-types'

import { icons, permissionPresets, services } from '@/utils'

import { getTabs } from '@/components/services/sendings/utils'

import render from './render'

numeral.locale('en')

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: undefined
    },

    providers: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentTab: 'format'
    }
  },

  computed: {
    tabs() {
      return getTabs(this.value, this.checkPermissions(`advanced.${services.sendings}.get`, permissionPresets.managerUp))
    },

    messageOnModeration() {
      const replacement = this.getReplacement('state.moderation')

      return replacement === MODERATION_VALUES.pending
    },

    fallbacksCount() {
      const fallbacks = this.value?.fallbacks || []
      const source = this.value?.meta?._specific?.source

      let result
      if (Array.isArray(fallbacks) && fallbacks.length) {
        result = fallbacks.length
      } else if (source === 'fallback') {
        result = 0
      }

      return result
    },

    textMisc() {
      const length = this.value?.meta?.stats?.characters || 0
      const segments = this.value?.meta?.stats?.segments || 0
      const result = [ length, segments ]
      if (this.value?.type === SendingTypes.voice) {
        const billSec = this.value?.state?.communications?.[0]?.response?.body?.billsec || 0
        result.push(billSec)
      }

      return result.map(item => numeral(item).format('0a')).join(' | ')
    },

    canViewOwner() {
      return this.checkPermissions(`advanced.${services.users}.get`, permissionPresets.resellerUp)
    }
  },

  methods: {
    getReplacement(field) {
      if (this.checkPermissions(`advanced.${services.sendings}.find`, permissionPresets.managerUp)) {
        const contentHistory = this.value?.meta?.contentHistory
        if (Array.isArray(contentHistory) && contentHistory.length) {
          const [ original, replacement, provider ] = contentHistory

          const originalValue = get(original, field)
          const replacementValue = get(replacement, field)
          const providerValue = get(provider, field, replacementValue)

          if (originalValue !== providerValue) {
            return providerValue
          }
        }
      }
    },

    getReplacementBadge(replacement) {
      const result = {}
      if (replacement) {
        result.badge = icons.repeat
        result.badgeProps = {
          color: Colors.success,
          rounded: true,
          offset: 'out',
          tooltip: this.getTranslate(`${services.sendings}.tooltips.replacement`)
        }
      }

      return result
    },

    clickHandler() {
      this.$el.scrollIntoView({
        behavior: 'instant',
        block: 'center'
      })
    }
  },

  render
}
